import apiAllUsers from '@/api/all-users'
import {pathOr} from 'ramda'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null,
  total: null,
}

export const mutationTypes = {
  updateAllUsersStart: '[update all users] Update all users start',
  updateAllUsersSuccess: '[update all users] Update all users success',
  updateAllUsersFailure: '[update all users] Update all users failure',

  getAllUsersStart: '[update all users] Get all users start',
  getAllUsersSuccess: '[update all users] Get all users success',
  getAllUsersFailure: '[update all users] Get all users failure',
}

export const actionTypes = {
  updateAllUsers: '[update all users] Update all users',
  getAllUsers: '[update all users] Get all users',
}

const mutations = {
  [mutationTypes.updateAllUsersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateAllUsersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateAllUsersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getAllUsersStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getAllUsersSuccess](state, payload) {
    state.data = payload
    state.total = pathOr(0, ['data', 'total'], payload)
    state.isLoading = false
  },

  [mutationTypes.getAllUsersFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateAllUsers](context, {id, allUsersInput}) {
    context.commit(mutationTypes.updateAllUsersStart)
    return new Promise((resolve) => {
      apiAllUsers
        .updateAllUsers(id, allUsersInput)
        .then((response) => {
          context.commit(mutationTypes.updateAllUsersSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateAllUsersFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getAllUsers](context, {id, params}) {
    context.commit(mutationTypes.getAllUsersStart)
    return new Promise((resolve) => {
      apiAllUsers
        .getAllUser(id, params)
        .then((response) => {
          context.commit(mutationTypes.getAllUsersSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getAllUsersFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
